export const APPLICATION_ROUTES = {
  login: '/login',
  signUp: '/sign-up',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  verifyEmail: '/verify-email',
  verifyEmailChange: '/verify-email-change',
  acceptInvitation: '/accept-invitation',
  unsubscribe: '/unsubscribe',
  legalDocument: '/legal/:documentSlug',
  accessError: '/access-error',
  workspaceDashboard: '/workspace',
  workspaceBranding: '/workspace/branding',
  workspaceClients: '/workspace/clients',
  workspaceClientImport: '/workspace/clients/import',
  workspaceClientDetail: '/workspace/clients/:clientId',
  workspacePatients: '/workspace/patients',
  workspacePatientDetail: '/workspace/patients/:patientId',
  workspacePatientSessionNote: '/workspace/patients/:patientId/session-notes/:noteId',
  workspacePatientFirstConsultation:
    '/workspace/patients/:patientId/first-consultation/:consultationId',
  workspacePatientTreatmentPlan: '/workspace/patients/:patientId/treatment-plan/:planId',
  workspaceIntake: '/workspace/intake',
  workspaceIntakeSubmission: '/workspace/intake/:submissionId',
  workspaceConsents: '/workspace/consents',
  workspaceSettings: '/workspace/settings',
  workspaceReports: '/workspace/reports',
  workspaceTeam: '/workspace/team',
  workspaceOrganization: '/workspace/organization',
  workspaceOrganizationMembers: '/workspace/organization?tab=members',
  workspaceNotifications: '/workspace/notifications',
  workspaceBroadcasts: '/workspace/announcements',
  workspaceBroadcastCompose: '/workspace/announcements/new',
  workspaceBroadcastDetail: '/workspace/announcements/:broadcastId',
  workspaceChat: '/workspace/chat',
  workspaceChatConversation: '/workspace/chat/:conversationId',
  workspaceSupport: '/workspace/support',
  workspaceSupportTicket: '/workspace/support/:ticketId',
  calendarSyncCallback: '/calendar-sync/callback',
  clientPortal: '/portal',
  clientPortalPets: '/portal/pets',
  clientPortalPet: '/portal/pets/:patientId',
  clientPortalVisits: '/portal/visits',
  clientPortalForms: '/portal/forms',
  clientPortalAccount: '/portal/account',
  clientPortalIntake: '/portal/intake',
  clientPortalIntakeSubmission: '/portal/intake/:submissionId',
  clientPortalAnnouncements: '/portal/announcements',
  clientPortalNotifications: '/portal/notifications',
  clientPortalChat: '/portal/chat',
  clientPortalChatConversation: '/portal/chat/:conversationId',
  adminDashboard: '/admin',
  adminNotifications: '/admin/notifications',
  adminPractitioners: '/admin/practitioners',
  adminTenantDetail: '/admin/practitioners/:tenantId',
  adminAccessControl: '/admin/access',
  adminUsers: '/admin/users',
  adminRoles: '/admin/roles',
  adminAuditLog: '/admin/audit-log',
  adminSupport: '/admin/support',
  adminAssistant: '/admin/assistant',
  adminSupportTicket: '/admin/support/:ticketId',
  adminProfile: '/admin/profile',
} as const;

export type ApplicationRoute = (typeof APPLICATION_ROUTES)[keyof typeof APPLICATION_ROUTES];
